import { TS_Item }     from 'Models/TravelSeller/Models/TS_Item';
import { TS_ItemType } from './TS_ItemType';

export class TS_Note extends TS_Item {
    type = TS_ItemType.NOTE;
}